// CORS Error Handler for Supabase
import { supabase } from '../services/supabaseClient';

// Global CORS error handler
export const setupCorsErrorHandler = () => {
  // Override fetch to detect CORS errors
  const originalFetch = window.fetch;
  
  window.fetch = async (...args) => {
    try {
      const response = await originalFetch(...args);
      return response;
    } catch (error) {
      // Check if this is a CORS error for Supabase
      const url = args[0]?.toString() || '';
      if (url.includes('supabase.co') && 
          (error.message?.includes('CORS') || 
           error.message?.includes('Failed to fetch') ||
           error.name === 'TypeError')) {
        
        console.error('CORS Error detected:', {
          url,
          error: error.message,
          timestamp: new Date().toISOString()
        });
        
        // Store error info for debugging
        const corsErrors = JSON.parse(localStorage.getItem('cors_errors') || '[]');
        corsErrors.push({
          url,
          error: error.message,
          timestamp: new Date().toISOString(),
          userAgent: navigator.userAgent
        });
        
        // Keep only last 10 errors
        if (corsErrors.length > 10) {
          corsErrors.shift();
        }
        
        localStorage.setItem('cors_errors', JSON.stringify(corsErrors));
      }
      
      throw error;
    }
  };
};

// Check if current domain is allowed
export const checkCorsConfiguration = async () => {
  try {
    // Try a simple auth check
    const { error } = await supabase.auth.getSession();
    
    if (error && (error.message?.includes('CORS') || error.message?.includes('Failed to fetch'))) {
      return {
        corsEnabled: false,
        error: 'CORS klaida. Patikrinkite ar jūsų domenas yra įtrauktas į Supabase leidžiamų domenų sąrašą.',
        domain: window.location.origin
      };
    }
    
    return {
      corsEnabled: true,
      domain: window.location.origin
    };
  } catch (error) {
    return {
      corsEnabled: false,
      error: error.message,
      domain: window.location.origin
    };
  }
};

// Get CORS error history
export const getCorsErrorHistory = () => {
  return JSON.parse(localStorage.getItem('cors_errors') || '[]');
};

// Clear CORS error history
export const clearCorsErrorHistory = () => {
  localStorage.removeItem('cors_errors');
};